import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: {
    id: 'recovery_forgot_password.title',
  },
  formSubTitle: {
    id: 'recovery_forgot_password.option_recovery_sub_title',
  },
  email: {
    id: 'recovery_forgot_password.email',
  },
  emailOption: {
    id: 'recovery_forgot_password.email_option',
  },
  questionSecret: {
    id: 'recovery_forgot_password.question_secret',
  },
  questionSecretOption: {
    id: 'recovery_forgot_password.question_secret_option',
  },
  chooseOption: {
    id: 'recovery_forgot_password.choose_option',
  },
  phone: {
    id: 'recovery_forgot_password.phone',
  },
  phoneOption: {
    id: 'recovery_forgot_password.phone_option',
  },
});
